const awsconfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION || 'us-east-1',
  aws_appsync_graphqlEndpoint:
    process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT ||
    'https://dul352o6iraqnkebsserufnfiu.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region:
    process.env.REACT_APP_AWS_APPSYNC_REGION ||
    process.env.REACT_APP_AWS_PROJECT_REGION ||
    'us-east-1',
  aws_appsync_authenticationType:
    process.env.REACT_APP_AWS_APPSYNC_AUTHENTICATION_TYPE ||
    'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_region:
    process.env.REACT_APP_AWS_COGNITO_REGION ||
    process.env.REACT_APP_AWS_PROJECT_REGION ||
    'us-east-1',
  aws_user_pools_id:
    process.env.REACT_APP_AWS_USER_POOLS_ID || 'us-east-1_ZG3Eb3jGn',
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ||
    '1cf8q2t1dq0h87gmv347ihi9lh',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default awsconfig;
